import React, {useState} from "react";
import {selfcareChangeMobile} from "../../../util/request";
import {useCustomer} from "../../../layouts/SelfcareLayout";
import LoaderSpinner from "../../loaders/LoaderSpinner";
import Routing from "../../../Routing.ts";
import {Link} from "react-router-dom";


export default function ChangeMobile(props: {setIsChangingMobileTo: (v: string|null) => void}) {
    const {customer} = useCustomer()
    const {setIsChangingMobileTo} = props;

    const [loading, setLoading] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null)
    const [successMessage, setSuccessMessage] = useState<string | null>(null)
    const [newMobile, setNewMobile] = useState<number>(0);
    const [newMobileRepeat, setNewMobileRepeat] = useState<number>(0);

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (newMobile !== newMobileRepeat) {
            setErrorMessage("De to mobilnumre er ikke ens");
            return
        }

        if(newMobile < 11111111) {
            setErrorMessage("Nummeret er for kort")
            return;
        }

        if(newMobile > 99999999) {
            setErrorMessage("Nummeret er for langt")
            return;
        }

        setLoading(true);

        selfcareChangeMobile(customer.customer_id, newMobile).then(r => {
            if (r.code !== 200) {
                setErrorMessage("Noget gik galt.")
                return
            }
            setSuccessMessage('Sådan! Du modtager snart en sms, hvor du skal godkende skiftet.')
            setIsChangingMobileTo(r.response.data.mobile_new);
        }).catch(() => {
            setErrorMessage('Der skete desværre en fejl. Prøv igen.')
        }).finally(() => {
            setLoading(false)
        })
    }

    const handleNewMobile = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewMobile(e.target.valueAsNumber);

        if (errorMessage !== "") {
            setErrorMessage("");
        }
    }

    const handleNewMobileRepeat = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewMobileRepeat(e.target.valueAsNumber);

        if (errorMessage !== "") {
            setErrorMessage("");
        }
    }

    return (
        <form className="selfcare-account-form visible" onSubmit={handleSubmit}>
            <p style={{display:"flex"}}>
                <input
                    type="number"
                    placeholder="Nummer"
                    onChange={handleNewMobile}
                    required
                />
            </p>
            <p style={{display:"flex"}}>
                <input
                    type="number"
                    placeholder="Gentag nummer"
                    onChange={handleNewMobileRepeat}
                    required
                />
            </p>

            {errorMessage && <p className="selfcare-message-error">{errorMessage}</p>}

            <p className="selfcare-explainer">
                Når du skifter dit mobilnummer, sender vi efterfølgende en SMS til det nye nummer med en kode.
                Koden skal du bruge til at bekræfte ændringen.
            </p>
            <p className="selfcare-explainer">
                Når du ændrer dit mobilnummer, betragter vi det ikke som en overdragelse. Hvis du vil overdrage dit abonnement til en anden
                person, skal du <Link to={Routing.Contact.Index}>kontakte vores kundeservice</Link>.
            </p>

            {loading ? <LoaderSpinner/> :
                <p className="submit-button-block">
                    <label id="submit-form-button" className="button teal">
                        <input disabled={loading} className="continue-button-submit" type="submit"/>
                        <span className="text">Skift nummer</span>
                    </label>
                </p>
            }

            {successMessage && <p className="selfcare-message-success">{successMessage}</p>}
        </form>
    )
}
